import { VideoInfo } from './videoTutorialUtils';

const S3_URL = 'https://cdn.blisspointmedia.com/apptutorialvideos/';

// This is a mapping of the page types to video name arrays.
const urlVideoMap: Record<string, string[]> = {
  'AMC Insights': ['AMC Insights'],
  Benchmarking: ['Benchmarking'],
  'Billing Automation': ['Billing Automation'],
  'Budget Intake Tool': ['Budget Intake Tool'],
  'Goal Intake': ['Goal Intake Tool'],
  Commerce: ['Commerce Single Channel'],
  'Commerce Ops': ['Commerce Ops'],
  'Creative Map': ['Creative Map', 'Best Practice Scoring'],
  'Cross-Channel': [
    'Bliss Point Overview',
    'Delivery & Performance',
    'Metrics Table',
    'Total Business'
  ],
  'Customer Insights': ['Customer Insights'],
  'Edit Client': ['Edit Client'],
  'KPI Mapping': ['KPI Mapping'],
  'Meta Buying': ['Meta Buying Creation Walkthrough', 'Meta Buying Drafts'],
  'Meta Lift Study': ['Meta Lift Study'],
  MMM: ['rMMM Model Overview', 'rMMM Saturation and Spend Decay'],
  Pacing: ['Pacing and Performance'],
  'Segmentation Mapping': ['Segmentation Mapping', 'Segmentation Labeling Rules'],
  Social: ['Social Single Channel'],
  'User Admin': ['User Admin']
};

export const getVideosForPage = (page: string): VideoInfo[] => {
  const videoNames = urlVideoMap[page];
  if (!videoNames) {
    return [];
  }

  const flattenedVideoNames = videoNames.flatMap(videoName =>
    videoName.split(',').map(name => name.trim())
  );
  return flattenedVideoNames.map(videoName => ({
    title: videoName,
    content: '',
    uploadDate: '',
    videoCreator: '',
    videoFile: `${S3_URL}${videoName.replace(/ /g, '_')}.mp4`,
    thumbnailFile: `${S3_URL}Thumbnails/${videoName.replace(/ /g, '_')}.png`
  }));
};

export type HelpToURL = Record<string, HelpDeskLink[]>;
export interface HelpDeskLink {
  title: string;
  url: string;
  content: string;
}

const helpToURL: HelpToURL = {
  'Common Issues': [
    {
      title: 'Report a Visual / Functional Issue',
      url: 'https://tinuiti.atlassian.net/servicedesk/customer/portal/8/group/136/create/511',
      content: 'Report problems with features, visualizations, or unexpected behavior.'
    },
    {
      title: 'Report a Data Issue',
      url: 'https://tinuiti.atlassian.net/servicedesk/customer/portal/8/group/136/create/592',
      content: 'Report data delays, discrepancies, or other data-related issues.'
    },
    {
      title: 'Provide Feedback / Feature Request',
      url: 'https://tinuiti.atlassian.net/servicedesk/customer/portal/8/group/136/create/509',
      content: 'Share feedback or request new features for the BlissPoint App.'
    }
  ],
  'Advanced Requests': [
    {
      title: 'Set Up New Data Source',
      url: 'https://tinuiti.atlassian.net/servicedesk/customer/portal/8/group/103/create/215',
      content: 'Request activation of a standard dataset (submit one ticket per dataset).'
    },
    {
      title: 'Create New MMM Model',
      url: 'https://tinuiti.atlassian.net/servicedesk/customer/portal/8/group/136/create/591',
      content: 'Kick off and track a new MMM modeling project.'
    },
    {
      title: 'Provide Access to the BlissPoint App',
      url: 'https://tinuiti.atlassian.net/servicedesk/customer/portal/8/group/136/create/512',
      content: "Request a new user account or gain access to a client's instance of the app."
    },
    {
      title: 'Request Single Channel Dashboard',
      url: 'https://tinuiti.atlassian.net/servicedesk/customer/portal/8/group/136/create/633',
      content: 'Enable Single Channel pages for one or more channels.'
    }
  ]
};

export const getHelpDeskContent = (topic: string): HelpDeskLink[] => {
  const helpDeskLinks = helpToURL[topic];
  if (!helpDeskLinks) {
    return [];
  }

  return helpDeskLinks;
};
